import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import React, {useState} from 'react';
import {SportEventMember} from '../../types/dto';

interface UpdatePasswordModalProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  sportEventMemberData?: SportEventMember;
  handleUpdate: (userId: number, newPassword: string) => void;
}

const UpdatePasswordModal: React.FC<UpdatePasswordModalProps> = ({
                                                                   isOpen,
                                                                   onOpen,
                                                                   onClose,
                                                                   sportEventMemberData,
                                                                   handleUpdate
                                                                 }) => {
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = () => {
    handleUpdate(
      sportEventMemberData!.userId,
      newPassword);
    setNewPassword('');
    onClose();
  };

  const handleCancel = () => {
    setNewPassword('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel}>
      <ModalOverlay/>
      <ModalContent>
        <ModalHeader>Change Password</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input type="text" value={sportEventMemberData?.firstName + ' ' + sportEventMemberData?.lastName} isReadOnly/>
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>New Password</FormLabel>
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isDisabled={!newPassword.trim()}
          >
            Update
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UpdatePasswordModal;
